import * as React from "react"
import { PlanFeatureTypes } from "util/constants"
import {
  welcomeToLuzSteps,
  competitorOverviewSteps,
  competitorProductsSteps,
  attributionOverviewSteps,
  findWebsiteConversionRateSteps,
  findHighestValueProductsSteps,
} from "data/tour-steps"

export interface TourDef {
  title: string
  tourSteps: {
    selector: string
    content: React.ReactNode
  }[]
  requiredFeatures: PlanFeatureTypes[]
}

const toursData = {
  welcome: {
    title: "Welcome to Luz",
    tourSteps: welcomeToLuzSteps,
    startingPathname: "/dashboard",
    showInHelpMenu: false,
  },
  understandCompetitorsPortfolio: {
    title: "Understand your competitor portfolio",
    tourSteps: competitorOverviewSteps,
    requiredFeatures: ["addRemoveCompetitors"],
    startingPathname: "/dashboard/companies/overview",
    showInHelpMenu: true,
  },
  understandCompetitorsPortfolioProducts: {
    title: "Understand competitor top products",
    tourSteps: competitorProductsSteps,
    requiredFeatures: ["addRemoveCompetitors"],
    startingPathname: "/dashboard/companies/products",
    showInHelpMenu: true,
  },
  understandAttribution: {
    title: "Learn how attribution works",
    tourSteps: attributionOverviewSteps,
    requiredFeatures: ["pixelAttribution"],
    startingPathname: "/dashboard/attribution/overview",
    showInHelpMenu: true,
  },
  findWebsiteConversionRate: {
    title: "Find your website conversion rate",
    tourSteps: findWebsiteConversionRateSteps,
    requiredFeatures: ["businessIntelligence"],
    startingPathname: "/dashboard/store/overview",
    showInHelpMenu: false,
  },
  findHighestValueProducts: {
    title: "Find your highest value products",
    tourSteps: findHighestValueProductsSteps,
    requiredFeatures: ["businessIntelligence"],
    startingPathname: "/dashboard/store/pages",
    showInHelpMenu: true,
  },
}

export type TourIds = keyof typeof toursData

export { toursData }
